<template>
  <v-app>
  <v-container fluid class="mt-3">
    <v-row class="ml-1 mr-1">
      <v-col class="pb-2 pl-2 pr-1" cols="12" lg="4" md="4" sm="12" >
        <v-card class="mx-1 mb-1">
          <v-card-title class="pl-5 pb-0">
            <v-row class="mb-3" no-gutters>
              <v-col cols="12" md="12">
                <table style="width: 100%;">
                  <tr>
                    <td><div style="font-size: 14pt; font-weight: bold; margin: 0; padding: 0; margin-top: 0;"><b>My {{ initvalue.schedulename }}</b></div></td>
                    <td style="text-align: right; margin: 0; padding: 0;"><div style="font-weight: 500; padding: 0;"><b>{{ formatMonth(initvalue.schedulestartdate) }}</b></div></td>
                  </tr>
                  <tr>
                    <td colspan="2" style=" margin: 0; padding: 0;"><div style="font-size: 12pt; font-weight:500; "><b>{{ name }}</b></div></td>
                  </tr>
                </table>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text class="pl-5 pt-0 pb-0">
            <v-row class="mb-4" v-for="(item, index1) in getMonthRange()" :key="index1" no-gutters>
                  <v-col class="ma-0" cols="12" md="12">
                    <table style="width: 100%;">
                      <tr>
                        <td style=" padding-left: 5px;">
                          <div style="align-content: center; height: 100%; font-size: 11pt; font-weight: 700; color: #111;">{{ formatShortDate(item).toUpperCase() }}</div>
                        </td>
                        <td style="text-align: right; padding-right: 20px;">
                          <div style="align-content: center; height: 100%; font-size: 10pt; font-weight: 400; color: #222;">{{ formatDay(item) }}</div>
                        </td>
                      </tr>
                    </table>
                    <v-divider style="padding-bottom: 5px;"></v-divider>
                  </v-col>
                  <v-col v-for="(trans, index) in getSchedule(item)" :key="index" class="ma-0 pa-0" cols="12" md="12">
                    <v-chip
                      v-if="trans!=null"
                      medium
                      class="greyBold--text d-block mt-1 mb-1 font-weight-regular"
                      :color="scheduleColor[trans.scheduletype]"
                    >
                      <v-icon :color="scheduleIconColor[trans.scheduletype]" left size="18" class="ml-0 mr-2">{{ `${scheduleIcon[trans.scheduletype]}` }}</v-icon>
                      <div v-if="['Holiday'].indexOf(trans.scheduletype)!=-1"><span style="font-size: 10pt;font-weight: 600;">{{ `${trans.scheduletype} ` }}</span><span style="font-size: 10pt;">{{ `(${trans.scheduledesc})` }}</span></div>
                      <div v-else-if="['Annual Leave', 'Sick Leave', 'Other Leave'].indexOf(trans.scheduletype)!=-1"><span style="font-size: 10pt;font-weight: 600;">{{ `${trans.scheduletype} `}}</span><span style="font-size: 10pt;">{{ `(${trans.scheduledesc})` }}</span></div>
                      <div v-else><span style="font-size: 10pt;font-weight: 600;">{{ `${trans.scheduletype}: ` }}</span><span style="font-size: 10pt;">{{  `${trans.starttime}-${trans.endtime}` }}</span></div>
                    </v-chip>
                  </v-col>
                  <v-col v-if="getSchedule(item).length==0" class="ma-0 pa-0" cols="12" md="12">
                    <v-chip
                      medium
                      class="greyBold--text d-block mt-1 mb-1 font-weight-regular"
                      :color="scheduleColor['No Work Shift']"
                    >
                      <v-icon color="f8f8f8" left size="18" class="ml-0 mr-2">{{ `${scheduleIcon['No Work Shift']}` }}</v-icon>
                      No Work Shift
                    </v-chip>
                  </v-col>
            </v-row>
            <div style="padding-bottom: 5px;"></div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col class="pb-2" cols="12" lg="8" md="8" sm="12">
        <v-row no-gutters>
          <v-col cols="12" md="12" sm="12">
            <v-card class="mx-1 mb-1">
              <v-card-title class="pl-5 pb-0">
                <v-row class="mb-3" no-gutters>
                  <v-col cols="12" md="12">
                    <table style="width: 100%;">
                      <tr>
                        <td><div style="font-size: 13pt; font-weight: bold; margin: 0; padding: 0; margin-top: 0;"><b>Team On-Leave</b></div></td>
                        <td style="text-align: right; margin: 0; padding: 0;"><div style="font-size: 11pt; font-weight: 500; padding: 0;"><b>{{ formatMonth(initvalue.schedulestartdate) }}</b></div></td>
                      </tr>
                    </table>
                  </v-col>
                </v-row>
              </v-card-title>
              <v-card-text class="pl-5 pt-0 pb-0">
                <v-row class="mb-4" no-gutters>
                  <v-col class="pl-1 pr-1" v-for="(item, index) in Object.keys( getScheduleTeamLeave() ) " :key="index" cols="12" md="3" sm="12">
                    <v-row class="mb-4" no-gutters>
                      <v-col cols="12" md="12">
                        <table style="width: 100%;">
                          <tr>
                            <td style=" padding-left: 5px;">
                              <div style="align-content: center; height: 100%; font-size: 11pt; font-weight: 700; color: #111;">{{ formatShortDate(item).toUpperCase() }}</div>
                            </td>
                            <td style="text-align: right; padding-right: 20px;">
                              <div style="align-content: center; height: 100%; font-size: 10pt; font-weight: 400; color: #222;">{{ formatDay(item) }}</div>
                            </td>
                          </tr>
                        </table>
                        <v-divider style="padding-bottom: 5px;"></v-divider>
                      </v-col>
                      <v-col v-for="(trans, index) in getScheduleTeamLeave()[item]" :key="index" class="ma-0 pr-2" cols="12" md="12">
                        <v-chip
                          v-if="trans!=null"
                          medium
                          class="greyBold--text d-block mt-1 mb-1 font-weight-regular"
                          :color="scheduleColor[trans.scheduletype]"
                        >
                          <v-icon :color="scheduleIconColor[trans.scheduletype]" left size="18" class="ml-0 mr-2">{{ `${scheduleIcon[trans.scheduletype]}` }}</v-icon>
                          <div v-if="['Annual Leave', 'Sick Leave', 'Other Leave'].indexOf(trans.scheduletype)!=-1"><span style="font-size: 9pt; font-weight: 600;">{{  `${trans.employeename}`  }}</span>&nbsp;<span style="font-size: 8pt;">{{  `(${getCode(trans.scheduletype)}${trans.scheduledesc!=null && trans.scheduledesc!='' ? '-' + trans.scheduledesc : ''})`  }}</span></div>
                          <div v-else><span style="font-size: 9pt; font-weight: 600;">{{ trans.employeename}}:&nbsp;</span><span style="font-size: 8pt;">{{`${trans.starttime}-${trans.endtime}` }}</span></div>                  
                        </v-chip>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="12" sm="12">
            <v-card class="mx-1 mb-1">
              <v-card-title class="pl-5 pb-0">
                <v-row class="mb-3" no-gutters>
                  <v-col cols="12" md="12">
                    <table style="width: 100%;">
                      <tr>
                        <td><div style="font-size: 13pt; font-weight: bold; margin: 0; padding: 0; margin-top: 0;"><b>Team Shift</b></div></td>
                        <td style="text-align: right; margin: 0; padding: 0;"><div style="font-size: 11pt; font-weight: 500; padding: 0;"><b>{{ formatMonth(initvalue.schedulestartdate) }}</b></div></td>
                      </tr>
                    </table>
                  </v-col>
                </v-row>
              </v-card-title>
              <v-card-text class="pl-5 pt-0 pb-0">
                <v-row class="mb-4" v-for="(item) in getMonthRange()" :key="item.toString()" no-gutters>
                      <v-col class="ma-0" cols="12" md="12">
                        <table style="width: 100%;">
                          <tr>
                            <td style=" padding-left: 5px;">
                              <div style="align-content: center; height: 100%; font-size: 11pt; font-weight: 700; color: #111;">{{ formatShortDate(item).toUpperCase() }}</div>
                            </td>
                            <td style="text-align: right; padding-right: 20px;">
                              <div style="align-content: center; height: 100%; font-size: 10pt; font-weight: 400; color: #222;">{{ formatDay(item) }}</div>
                            </td>
                          </tr>
                        </table>
                        <v-divider style="padding-bottom: 5px;"></v-divider>
                      </v-col>
                      <v-col v-for="(trans, index) in getScheduleHoliday(item)" :key="index" class="ma-0 pr-2" cols="12" md="12">
                        <v-chip
                          v-if="trans!=null"
                          medium
                          class="greyBold--text d-block mt-1 mb-1 font-weight-regular"
                          :color="scheduleColor[trans.scheduletype]"
                        >
                          <v-icon :color="scheduleIconColor[trans.scheduletype]" left size="18" class="ml-0 mr-2">{{ `${scheduleIcon[trans.scheduletype]}` }}</v-icon>
                          <span style="font-size: 9pt; font-weight: 600;">{{ `${trans.scheduletype}`}}</span>&nbsp;<span style="font-size: 9pt;"> {{ `(${trans.scheduledesc})` }}</span>
                        </v-chip>
                      </v-col>
                      <v-col v-for="(trans, index) in getScheduleTeam(item)" :key="index" class="ma-0 pr-2" cols="12" md="3">
                        <v-chip
                          v-if="trans!=null"
                          medium
                          class="greyBold--text d-block mt-1 mb-1 font-weight-regular"
                          :color="scheduleColor[trans.scheduletype]"
                        >
                          <v-icon :color="scheduleIconColor[trans.scheduletype]" left size="18" class="ml-0 mr-2">{{ `${scheduleIcon[trans.scheduletype]}` }}</v-icon>
                          <div v-if="['Annual Leave', 'Sick Leave', 'Other Leave'].indexOf(trans.scheduletype)!=-1"><span style="font-size: 9pt; font-weight: 600;">{{  `${trans.employeename}`  }}</span>&nbsp;<span style="font-size: 8pt;">{{  `(${getCode(trans.scheduletype)}${trans.scheduledesc!=null && trans.scheduledesc!='' ? '-' + trans.scheduledesc : ''})`  }}</span></div>
                          <div v-else><span style="font-size: 9pt; font-weight: 600;">{{ trans.employeename}}:&nbsp;</span><span style="font-size: 8pt;">{{`${trans.starttime}-${trans.endtime}` }}</span></div>                  
                        </v-chip>
                      </v-col>

                      <v-col v-if="getScheduleTeam(item).length==0 && getScheduleHoliday(item).length==0" class="ma-0 pa-0" cols="12" md="12">
                        <v-chip
                          medium
                          class="greyBold--text d-block mt-1 mb-1 font-weight-regular"
                          :color="scheduleColor['No Work Shift']"
                        >
                          <v-icon color="f8f8f8" left size="18" class="ml-0 mr-2">{{ `${scheduleIcon['No Work Shift']}` }}</v-icon>
                          No Work Shift
                        </v-chip>
                      </v-col>
                </v-row>
                <div style="padding-bottom: 5px;"></div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
  </v-app>
</template>


<script>
    import {mapActions, mapState} from "vuex";
    import { formatShortDate, formatDay, formatMonth } from '../../util/tools';

    export default {
        name: 'ViewShiftSchedule',
        props: {
          id: String
        },
        data(){
          return {
            initvalue: {},
            logo: null,
            name: null,
            scheduleColor: {
              'No Work Shift': '#fafafa',
              'Work from Office': '#536dfe26',
              'Work from Home': '#dbf3fa',
              'Work from Other': '#dbf3fa',
              'Business Travel': '#dbf3fa',
              'Contract Work': '#9013fe26',
              'Annual Leave': '#ffc26026',
              'Other Leave': '#ffc26026',
              'Sick Leave': '#ffc26026',
              'Holiday': '#3cd4a026',
            },
            scheduleIconColor: {
              'No Work Shift': '#f8f8f8',
              'Work from Office': '#536dfe',
              'Work from Home': '#50b8e7',
              'Work from Other': '#50b8e7',
              'Business Travel': '#50b8e7',
              'Contract Work': '#663399',
              'Annual Leave': '#FFC260',
              'Other Leave': '#FFC260',
              'Sick Leave': '#FFC260',
              'Holiday': '#3CB043',
            },
            scheduleIcon: {
              'No Work Shift': 'mdi-circle-outline',
              'Work from Office': 'mdi-office-building',
              'Work from Home': 'mdi-home',
              'Work from Other': 'mdi-store',
              'Business Travel': 'mdi-airplane',
              'Contract Work': 'mdi-briefcase-variant',
              'Annual Leave': 'mdi-calendar-heart',
              'Other Leave': 'mdi-calendar-multiselect',
              'Sick Leave': 'mdi-emoticon-sick-outline',
              'Holiday': 'mdi-island',
            },
            formatShortDate: formatShortDate,
            formatDay: formatDay,
            formatMonth: formatMonth,
          };
        },
        computed: {
          ...mapState('Region', ['regions']),
        },
        methods: {
          ...mapActions('ViewApi', ['getShiftScheduleRequest']),
          getCode(type){
            let words = type.split(" ");
            let text = words[0][0].toUpperCase() + words[1][0].toUpperCase();
            return text;
          },
          getMonthRange(){
            let range = [];
            if(this.initvalue==null) return range;
            let startdate = this.initvalue.schedulestartdate;
            let enddate = this.initvalue.scheduleenddate;
            let date = new Date(startdate);
            let edate = new Date(enddate);
            let i = 0;
            while (date <= edate) {
                range.push(date);
                date = new Date(new Date(date).getTime()+(1*24*60*60*1000));
                i = i+1;
            }
            return range;
          },
          getSchedule(date){
            let results = this.initvalue.transactions.filter(i=> new Date(i.scheduledate).getTime() == new Date(date).getTime());
            results.sort((a,b) =>{
                if (b.starttime > a.starttime) return -1;
                if (a.starttime < b.starttime) return 1;
                return 0;
            });
            return results;
          },
          getScheduleTeam(date){
            let results = this.initvalue.transactions_team.filter(i=> new Date(i.scheduledate).getTime() == new Date(date).getTime() && i.scheduletype!='Holiday');
            results.sort((a,b) =>{
                if (b.starttime > a.starttime) return -1;
                if (a.starttime < b.starttime) return 1;
                return 0;
            });
            return results;
          },
          getScheduleTeamLeave(){
            if(this.initvalue.transactions==null || this.initvalue.transactions_team==null) return [];
            let results = [...this.initvalue.transactions.filter(i=>i.scheduletype.includes('Leave')) ,...this.initvalue.transactions_team.filter(i=>i.scheduletype.includes('Leave'))]
            results.sort((a,b) =>{
                if (b.scheduledate > a.scheduledate) return -1;
                if (a.scheduledate < b.scheduledate) return 1;
                return 0;
            });
            let object = Object.groupBy(results, item => {
              return item.scheduledate;
            });
            return object;
          },
          getScheduleHoliday(date){
            let holidays = this.initvalue.transactions_team.filter(i=> new Date(i.scheduledate).getTime() == new Date(date).getTime() && i.scheduletype=='Holiday');
            let results = this.initvalue.transactions_team.filter(i=> new Date(i.scheduledate).getTime() == new Date(date).getTime() && i.scheduletype!='Holiday');
            results.sort((a,b) =>{
                if (b.starttime > a.starttime) return -1;
                if (a.starttime < b.starttime) return 1;
                return 0;
            });
            if(holidays.length==0) return [];
            return [holidays[0]];
          },
        },
        async created () {
          this.initvalue = await this.getShiftScheduleRequest(this.id);
        },
    };
</script>

<style src="./View.scss" lang="scss"/>
